module.exports = __webpack_public_path__ + "static/media/01_stepper_motor.25b99ffa.png";